import React, { useState, useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import Select from '../common/Select';

const IssueFilters = ({ filters, onFiltersChange, issues }) => {
  const { userProfile } = useAuth();
  const [availableAssignees, setAvailableAssignees] = useState([]);
  const [availableProjects, setAvailableProjects] = useState([]);

  useEffect(() => {
    // Extract unique assignees and projects from issues
    const assignees = [...new Set(issues.map(issue => issue.assigneeId).filter(Boolean))];
    const projects = [...new Set(issues.map(issue => issue.projectId))];
    
    setAvailableAssignees(assignees);
    setAvailableProjects(projects);
  }, [issues]);

  const statusOptions = [
    { value: 'all', label: 'All Statuses' },
    { value: 'todo', label: 'To Do' },
    { value: 'in-progress', label: 'In Progress' },
    { value: 'in-review', label: 'In Review' },
    { value: 'done', label: 'Done' }
  ];

  const priorityOptions = [
    { value: 'all', label: 'All Priorities' },
    { value: 'low', label: 'Low' },
    { value: 'medium', label: 'Medium' },
    { value: 'high', label: 'High' },
    { value: 'critical', label: 'Critical' }
  ];

  const handleFilterChange = (name, value) => {
    const newFilters = { ...filters, [name]: value };
    onFiltersChange(newFilters);
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 p-4 space-y-4">
      <h3 className="font-semibold text-gray-900 dark:text-white">Filters</h3>
      
      <Select
        label="Status"
        value={filters.status}
        onChange={(e) => handleFilterChange('status', e.target.value)}
        options={statusOptions}
      />
      
      <Select
        label="Priority"
        value={filters.priority}
        onChange={(e) => handleFilterChange('priority', e.target.value)}
        options={priorityOptions}
      />
      
      <Select
        label="Assignee"
        value={filters.assignee}
        onChange={(e) => handleFilterChange('assignee', e.target.value)}
        options={[
          { value: 'all', label: 'All Assignees' },
          { value: userProfile?.uid, label: 'Assigned to Me' },
          ...availableAssignees.map(assigneeId => {
            const issue = issues.find(i => i.assigneeId === assigneeId);
            return {
              value: assigneeId,
              label: issue?.assigneeName || 'Unknown'
            };
          })
        ]}
      />
      
      <Select
        label="Project"
        value={filters.project}
        onChange={(e) => handleFilterChange('project', e.target.value)}
        options={[
          { value: 'all', label: 'All Projects' },
          ...availableProjects.map(projectId => {
            const issue = issues.find(i => i.projectId === projectId);
            return {
              value: projectId,
              label: issue?.projectId || 'Unknown Project'
            };
          })
        ]}
      />
      
      <button
        onClick={() => onFiltersChange({
          status: 'all',
          priority: 'all',
          assignee: 'all',
          project: 'all'
        })}
        className="w-full px-3 py-2 text-sm text-gray-600 dark:text-gray-400 hover:text-gray-800 dark:hover:text-gray-200 border border-gray-300 dark:border-gray-600 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors"
      >
        Clear All Filters
      </button>
    </div>
  );
};

export default IssueFilters;